import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as elementStyles from "@universityofmaryland/web-styles-library/element";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import * as layout from "@universityofmaryland/web-styles-library/layout";
import * as animation from "@universityofmaryland/web-styles-library/animation";
import { wrapTextNodeInSpan } from "@universityofmaryland/web-utilities-library/dom";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
const ELEMENT_TEXT_LOCKUP_SMALL_CONTAINER = "text-lockup-small-container";
const metaContainer = elementStyles?.event?.meta?.container;
const metaClass = (() => {
  if (!metaContainer?.className) return "";
  if (Array.isArray(metaContainer.className)) {
    return metaContainer.className[0] || "";
  }
  if (typeof metaContainer.className === "string") {
    return metaContainer.className;
  }
  return "";
})();
const eyebrowStyles = {
  element: {
    display: "block",
    ["*"]: {
      color: "currentColor"
    }
  },
  siblingAfter: {
    marginTop: token.spacing.min
  }
};
const ribbonStyles = {
  siblingAfter: {
    marginTop: token.spacing.sm
  }
};
const headlineStyles = {
  element: {
    fontWeight: "700",
    [`& + *`]: {
      marginTop: token.spacing.sm
    },
    [`& + .${metaClass}`]: {
      [`@media (max-width: 479px)`]: {
        marginTop: token.spacing.min
      }
    }
  },
  subElement: {
    color: "currentColor"
  }
};
const textStyles = (isThemeDark) => ({
  element: {
    ...!isThemeDark && {
      color: `${token.color.gray.dark}`
    }
  },
  child: {
    ...!isThemeDark && {
      color: `${token.color.gray.dark}`
    }
  },
  siblingAfter: {
    marginTop: token.spacing.min
  }
});
const dateStyles = (isThemeDark) => ({
  element: {
    display: "block",
    ...!isThemeDark && {
      color: `${token.color.gray.mediumAA}`
    }
  },
  child: {
    color: "currentColor"
  },
  siblingAfter: {
    marginTop: token.spacing.min
  }
});
const createEyebrow = ({ eyebrow, isThemeDark }) => new ElementBuilder(eyebrow).styled(
  typography.elements.compose("eyebrow", {
    theme: theme.fontColor(isThemeDark)
  })
).withStyles(eyebrowStyles).build();
const createRibbonEyebrow = ({ eyebrow }) => new ElementBuilder(eyebrow).styled(elementStyles.text.decoration.ribbon).withStyles(ribbonStyles).build();
const createActions = ({ actions }) => new ElementBuilder(actions).styled(layout.grid.inline.tabletRows).withStyles({
  element: {
    marginTop: token.spacing.sm
  }
}).build();
const createTextLockupSmall = ({
  eyebrow,
  headline,
  text,
  actions,
  date,
  eventMeta,
  isThemeDark
}) => {
  const container = new ElementBuilder().withClassName(ELEMENT_TEXT_LOCKUP_SMALL_CONTAINER).withStyles({
    element: {
      zIndex: "9",
      position: "relative"
    }
  });
  if (eyebrow) {
    const eyebrowElement = createEyebrow({ eyebrow, isThemeDark });
    container.withChild(eyebrowElement);
  }
  if (headline) {
    const composeHeadlineStyles = {
      ...animation.line.composeSlideUnder({
        color: theme.foreground(isThemeDark)
      }),
      ...typography.sans.compose("larger", {
        theme: theme.fontColor(isThemeDark)
      })
    };
    const headlineElement = new ElementBuilder(headline).styled(composeHeadlineStyles).withStyles(headlineStyles).withModifier((el) => wrapTextNodeInSpan(el)).build();
    container.withChild(headlineElement);
  }
  if (eventMeta) {
    container.withChild(eventMeta);
  }
  if (text) {
    const textElement = new ElementBuilder(text).styled(
      elementStyles.text.rich.composeSimple({
        theme: theme.fontColor(isThemeDark)
      })
    ).withStyles(textStyles(isThemeDark)).build();
    container.withChild(textElement);
  }
  if (date) {
    const dateElement = new ElementBuilder(date).withClassName("umd-headline-sans-min").styled(
      typography.sans.compose("min", {
        theme: theme.fontColor(isThemeDark)
      })
    ).withAnimation("slideUnder").withStyles(dateStyles(isThemeDark)).build();
    container.withChild(dateElement);
  }
  if (actions) {
    const actionsElement = createActions({ actions });
    container.withChild(actionsElement);
  }
  return container.build();
};
export {
  createActions,
  createEyebrow,
  createRibbonEyebrow,
  createTextLockupSmall,
  dateStyles,
  eyebrowStyles,
  headlineStyles,
  ribbonStyles,
  textStyles
};
//# sourceMappingURL=small.js.map
